import clsx from 'clsx'
import {HTMLInputTypeAttribute, InputHTMLAttributes, MouseEvent, FocusEvent, useMemo} from 'react'
import {hexToRgba} from 'coop_quiz/src/utils/hexToRgba'

interface InputProps {
  label?: string
  className?: string
  value: string
  onChange?: InputHTMLAttributes<HTMLInputElement>['onChange']
  error?: string | boolean
  type?: HTMLInputTypeAttribute
  idLabel?: string
  idInput?: string
  required?: boolean
  bgColor?: string
  borderColor?: string
}

export const Input = ({
  value,
  type,
  label,
  onChange,
  className,
  error,
  idInput,
  idLabel,
  required,
  bgColor = '#252E5B',
  borderColor = '#FFFFFF',
}: InputProps) => {
  const borderColors = useMemo(() => {
    return {
      default: hexToRgba(borderColor, 0.3),
      hover: hexToRgba(borderColor, 0.6),
      focus: hexToRgba(borderColor, 1.0),
    }
  }, [borderColor])

  return (
    <div className={clsx(className, 'flex flex-col')}>
      <label id={idLabel} className="mb-1 text-[14px] uppercase text-white">
        {label}
        {required && <span className="ml-1 text-red-500">*</span>}
      </label>
      <input
        id={idInput}
        className={clsx(
          'pointer-events-auto',
          'h-[48px] rounded-lg px-4 py-[14px] text-base text-white',
          'border-[1px] outline-none transition-colors duration-200',
          error && 'border-red-500',
        )}
        style={{
          backgroundColor: bgColor,
          borderColor: error ? '' : borderColors.default,
        }}
        onMouseOver={(e: MouseEvent<HTMLInputElement>) => {
          if (!error) e.currentTarget.style.borderColor = borderColors.hover
        }}
        onMouseOut={(e: MouseEvent<HTMLInputElement>) => {
          if (!error) e.currentTarget.style.borderColor = borderColors.default
        }}
        onFocus={(e: FocusEvent<HTMLInputElement>) => {
          if (!error) e.currentTarget.style.borderColor = borderColors.focus
        }}
        onBlur={(e: FocusEvent<HTMLInputElement>) => {
          if (!error) e.currentTarget.style.borderColor = borderColors.default
        }}
        value={value}
        onChange={onChange}
        type={type}
      />
      {error && <div className="mt-1 text-sm font-medium text-red-500">{error}</div>}
    </div>
  )
}
